import { render, staticRenderFns } from "./PowerConsumptionInfo.vue?vue&type=template&id=decaaefe&scoped=true"
import script from "./PowerConsumptionInfo.vue?vue&type=script&lang=ts"
export * from "./PowerConsumptionInfo.vue?vue&type=script&lang=ts"
import style0 from "./PowerConsumptionInfo.vue?vue&type=style&index=0&id=decaaefe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decaaefe",
  null
  
)

export default component.exports